import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from 'components/widgets/Container';
import SettingsStyles from 'styles/modules/settings/SettingsStyles';
import {
    List, ListItem, ListItemIcon, ListItemText,
} from '@material-ui/core';

// icons
import AppsIcon from '@material-ui/icons/Apps';

import { useHistory, useParams } from 'react-router-dom';
// utils
import KeyStore from 'utils/KeyStore';
import Permission from 'utils/enum/Permissions';
import PortfolioSettingsList from 'components/modules/settings/bphp/portfolio/PortfolioSettingsList';
import BHPHGeneralSettings from 'components/modules/settings/bphp/BHPHGeneralSettings';
import NoPayOptionSettings from 'components/modules/settings/bphp/NoPayOptionSettings';
import NotificationSettings from './notificationSettings/NotificationSettings';
import ContractSettingListComponent from './contract/ContractSettingListComponent';

const useStyles = makeStyles((theme) => SettingsStyles.settingsPanelItem(theme));
const getSettings = (hasPortfolioReadPermission) => {
    const settings = [];
    settings.push(
        {
            index: 0,
            text: 'General',
            icon: <AppsIcon />,
            component: <BHPHGeneralSettings />,
        },
    );

    if (hasPortfolioReadPermission) {
        settings.push(
            {
                index: 1,
                text: 'Portfolio',
                icon: <AppsIcon />,
                component: <PortfolioSettingsList />,
            },
        );
    }

    settings.push(
        {
            index: hasPortfolioReadPermission ? 2 : 1,
            text: 'No Pay Options',
            icon: <AppsIcon />,
            component: <NoPayOptionSettings />,
        },
    );

    settings.push(
        {
            index: hasPortfolioReadPermission ? 3 : 2,
            text: 'Notifications',
            icon: <AppsIcon />,
            component: <NotificationSettings />,
        },
    );

    settings.push(
        {
            index: hasPortfolioReadPermission ? 4 : 3,
            text: 'Contracts',
            icon: <AppsIcon />,
            component: <ContractSettingListComponent />,
        },
    );

    return settings;
};

const BHPHSettings = () => {
    const keyStore = new KeyStore();
    const hasPortfolioReadPermission = keyStore.hasPermission(Permission.SETTINGS_BHPH_PORTFOLIO_READ);

    const subTabs = ['general', 'portfolio', 'no-pay-options', 'notifications', 'contracts']
        .filter((p) => hasPortfolioReadPermission || (!hasPortfolioReadPermission && p !== 'portfolio'));
    const getSelectedTab = (subtab) => {
        const tabIndex = subTabs.indexOf(subtab);
        if (tabIndex !== -1) return tabIndex;

        return 0;
    };

    const classes = useStyles();
    const history = useHistory();
    const { maintab, subtab } = useParams();
    const [activeIndex, setActiveIndex] = useState(getSelectedTab(subtab || 0));

    const handleChange = (newIndex) => {
        const tabName = subTabs[newIndex];
        if (tabName) {
            history.push(`/settings/${maintab || 'bhph'}/${tabName}`);
            setActiveIndex(newIndex);
        }
    };

    const settingsItems = getSettings(hasPortfolioReadPermission);

    return (
        <Container className={classes.rootContainer}>
            <List component="nav" className={classes.sideBar}>
                {settingsItems.map((item) => (
                    <ListItem key={item.index} onClick={() => handleChange(item.index)} button selected={activeIndex === item.index}>
                        <ListItemIcon>
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item.text} />
                    </ListItem>
                ))}
            </List>
            {settingsItems.map((item) => (
                activeIndex === item.index && <div className={classes.content} key={item.index}>{item.component}</div>
            ))}
        </Container>
    );
};

export default BHPHSettings;
